import React from 'react'
import styles from './styles.module.css'

import { A11y, Mousewheel, Navigation } from 'swiper/modules'
import { I18nHtml, NavigationArrow } from 'shared'
import { Swiper, SwiperSlide } from 'swiper/react'

export const CodonationReasons = () => {
  return (
    <div className={styles.reasonsWrapper}>
      <div className="h-full">
        <NavigationArrow id="reason-prev" direction="left" size="small" additionalClassName="mr-2" />
      </div>
      <Swiper
        modules={[Navigation, Mousewheel, A11y]}
        slidesPerView={1}
        pagination={false}
        navigation={{
          nextEl: `#reason-next`,
          prevEl: `#reason-prev`,
          disabledClass: 'is-disabled',
        }}
        spaceBetween={16}
        roundLengths
        mousewheel={{ forceToAxis: true }}
      >
        <SwiperSlide key={1} className={styles.reason}>
          <I18nHtml i18nKey="donate.codonation_reasons.reason_1_html" />
        </SwiperSlide>
        <SwiperSlide key={2} className={styles.reason}>
          <I18nHtml i18nKey="donate.codonation_reasons.reason_2_html" />
        </SwiperSlide>
        <SwiperSlide key={3} className={styles.reason}>
          <I18nHtml i18nKey="donate.codonation_reasons.reason_3_html" />
        </SwiperSlide>
      </Swiper>
      <NavigationArrow id="reason-next" direction="right" size="small" additionalClassName="ml-2" />
    </div>
  )
}
